<template>
  <ThePage :title="i18n(translations.pageTitle)">
    <template #pageTitle>
      {{ i18n(translations.title, { merchantName: companyName }) }}
    </template>

    <template #pageContent>
      <div class="space-y-24">
        <div class="md:grid md:grid-cols-4 md:gap-24">
          <TaskList class="col-span-1 mb-24 md:mb-0" />

          <div class="col-span-3 space-y-24">
            <SaleInsightsV2 v-if="isDynamicPricingUpSecondIterationEnabled" />
            <SaleInsights v-else />
          </div>
        </div>

        <div
          :class="isBuybackEnabled ? 'md:grid md:grid-cols-2 md:gap-24' : ''"
        >
          <TradeIn v-if="isBuybackEnabled" />
          <Opportunities />
        </div>

        <div class="md:grid md:grid-cols-2 md:gap-24">
          <Feedbacks />
          <Wallet />
        </div>
        <CustomerReviews class="mb-24 md:mb-0" />
      </div>

      <SignTermsAndConditionsModal />
      <TheFooter />
    </template>
  </ThePage>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import { useSellerInfoStore } from '~/scopes/auth/stores/sellerInfoStore'
import { useBusinessFeaturesStore } from '~/scopes/config/stores/businessFeaturesStore'

import translations from './Home.translations'
import CustomerReviews from './components/CustomerReviews/CustomerReviews.vue'
import Feedbacks from './components/Feedbacks/Feedbacks.vue'
import Opportunities from './components/Opportunities/Opportunities.vue'
import SaleInsights from './components/SaleInsights/SaleInsights.vue'
import SaleInsightsV2 from './components/SaleInsightsV2/SaleInsightsV2.vue'
import SignTermsAndConditionsModal from './components/SignTermsAndConditionsModal/SignTermsAndConditionsModal.vue'
import TaskList from './components/TaskList/TaskList.vue'
import TradeIn from './components/TradeIn/TradeIn.vue'
import Wallet from './components/Wallet/Wallet.vue'

const { isFeatureEnabled } = useBusinessFeaturesStore()

const isDynamicPricingUpSecondIterationEnabled = isFeatureEnabled(
  'isDynamicPricingUpSecondIterationEnabled',
)
const { companyName, isBuybackEnabled } = useSellerInfoStore()

const i18n = useI18n()
</script>
